import TextField from '@mui/material/TextField';
import type { TextFieldProps } from '@mui/material';
import { useMapsLibrary } from '@vis.gl/react-google-maps';
import React from 'react';

type PlaceAutocompleteProps = TextFieldProps & {
    onPlaceSelect: (place: google.maps.places.PlaceResult | null) => void;
};

type TF = typeof TextField;

export default (props: PlaceAutocompleteProps) => {

    const [placeAutocomplete, setPlaceAutocomplete] = React.useState<google.maps.places.Autocomplete | null>(null);
    const inputRef = React.useRef<HTMLInputElement | null>(null);
    const places = useMapsLibrary('places');

    React.useEffect(() => {

        if (!places || !inputRef.current) return;

        const options: google.maps.places.AutocompleteOptions = {
            fields: ['geometry', 'name', 'formatted_address'],
        };

        setPlaceAutocomplete(new places.Autocomplete(inputRef.current, options));

    }, [places]);

    React.useEffect(() => {

        if (!placeAutocomplete) return;

        placeAutocomplete.addListener('place_changed', () => {
            props.onPlaceSelect(placeAutocomplete.getPlace());
        });

    }, [props.onPlaceSelect, placeAutocomplete]);

    return (
        <div className="autocomplete-container">
            <TextField {...props} fullWidth inputRef={inputRef} />
        </div>
    );
};
